const routes = [
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import('@/views/admin/dashboard/index.vue'),
    meta: {
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/news',
    name: 'admin-news',
    component: () => import('@/views/admin/news/index.vue'),
    meta: {
      pageTitle: 'News',
      breadcrumb: [
        {
          text: 'News',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/notadinas',
    name: 'admin-nota-dinas',
    component: () => import('@/views/admin/notadinas/index.vue'),
    meta: {
      pageTitle: 'Nota Dinas',
      breadcrumb: [
        {
          text: 'Nota Dinas',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/notadinas/add',
    name: 'admin-nota-dinas-add',
    component: () => import('@/views/admin/notadinas/create.vue'),
    meta: {
      pageTitle: 'Nota Dinas',
      breadcrumb: [
        {
          text: 'Nota Dinas',
          to: '/admin/notadinas',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/notadinas/update/:key',
    name: 'admin-nota-dinas-update',
    component: () => import('@/views/admin/notadinas/update.vue'),
    meta: {
      pageTitle: 'Update Document Nota Dinas',
      breadcrumb: [
        {
          text: 'Nota Dinas',
          to: '/admin/notadinas',
        },
        {
          text: 'Update',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  // {
  //   path: '/admin/zona-tarif-inner',
  //   name: 'admin-zona-tarif-inner',
  //   component: () => import('@/views/admin/zonaTarifInner/index.vue'),
  //   meta: {
  //     pageTitle: 'Zona Tarif Inner',
  //     breadcrumb: [
  //       {
  //         text: 'Zona Tarif Inner',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/admin/zona-tarif-inner/add',
  //   name: 'admin-zona-tarif-inner-add',
  //   component: () => import('@/views/admin/zonaTarifInner/create.vue'),
  //   meta: {
  //     pageTitle: 'Zona Tarif Inner',
  //     breadcrumb: [
  //       {
  //         text: 'Zona Tarif Inner',
  //         to: '/admin/zona-tarif-inner',
  //       },
  //       {
  //         text: 'Add',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/admin/flip/book',
    name: 'admin-flip-book',
    component: () => import('@/views/admin/flipBook/Index.vue'),
    meta: {
      pageTitle: 'Flip Book',
      breadcrumb: [
        {
          text: 'Flip Book',
          active: true
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/contact-us-request',
    name: 'admin-contact-us-request',
    component: () => import('@/views/admin/contact-us-request/Index.vue'),
    meta: {
      pageTitle: 'Contact Us Request',
      breadcrumb: [
        {
          text: 'Contact Us Request',
          active: true
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/reservation-request',
    name: 'admin-reservation-request',
    component: () => import('@/views/admin/reservation-request/Index.vue'),
    meta: {
      pageTitle: 'Reservation Request',
      breadcrumb: [
        {
          text: 'Reservation Request',
          active: true
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/product-request',
    name: 'admin-product-request',
    component: () => import('@/views/admin/product-request/index.vue'),
    meta: {
      pageTitle: 'Product Request',
      breadcrumb: [
        {
          text: 'Product Request',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/product-request-detail/:key',
    name: 'admin-product-request-detail',
    component: () => import('@/views/admin/product-request/Detail.vue'),
    meta: {
      pageTitle: 'Product Request Detail',
      breadcrumb: [
        {
          text: 'Product Request',
          to: { name: 'admin-product-request' },
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/pricing-connectivity',
    name: 'pricing-connectivity',
    component: () => import('@/views/admin/pricing-connectivity/Index.vue'),
    meta: {
      pageTitle: 'Pricing Connectivity',
      breadcrumb: [
        {
          text: 'Pricing Connectivity',
          active: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/admin/list-comparison',
    name: 'admin-list-comparison',
    component: () => import('@/views/admin/pricing-connectivity/EditComparison.vue'),
    meta: {
      pageTitle: 'Competitor Comparison',
      breadcrumb: [
        {
          text: 'Competitor Comparison',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/tree',
    name: 'admin-tree',
    component: () => import('@/views/admin/tree/index.vue'),
    meta: {
      pageTitle: 'Product Tree',
      breadcrumb: [
        {
          text: 'Product Tree',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/tree/add',
    name: 'admin-tree-add',
    component: () => import('@/views/admin/tree/Create.vue'),
    meta: {
      pageTitle: 'Product Tree',
      breadcrumb: [
        {
          text: 'Product Tree',
          to: '/admin/tree',
        },
        {
          text: 'Product Tree Add',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/tree-detail/:key',
    name: 'admin-tree-detail',
    component: () => import('@/views/admin/tree/Edit.vue'),
    meta: {
      pageTitle: 'Product Tree Edit',
      breadcrumb: [
        {
          text: 'Product Tree',
          to: { name: 'admin-tree' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/podcast',
    name: 'admin-podcast',
    component: () => import('@/views/admin/podcast/index.vue'),
    meta: {
      pageTitle: 'Podcast',
      breadcrumb: [
        {
          text: 'Podcast',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/notification-center',
    name: 'admin-notification-center',
    component: () => import('@/views/admin/notification-center/Index.vue'),
    meta: {
      pageTitle: 'Notification Center',
      breadcrumb: [
        {
          text: 'Notification Center',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/notification-center/create',
    name: 'admin-notification-center-create',
    component: () => import('@/views/admin/notification-center/Form.vue'),
    meta: {
      pageTitle: 'Add Notification Center',
      breadcrumb: [
        {
          text: 'Notification Center',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/notification-center/:id',
    name: 'admin-notification-center-detail',
    component: () => import('@/views/admin/notification-center/Detail.vue'),
    meta: {
      pageTitle: 'Add Notification Center',
      breadcrumb: [
        {
          text: 'Notification Center',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/podcast/add',
    name: 'admin-podcast-add',
    component: () => import('@/views/admin/podcast/create.vue'),
    meta: {
      pageTitle: 'Podcast',
      breadcrumb: [
        {
          text: 'Podcast',
          to: '/admin/podcast',
        },
        {
          text: 'Podcast Add',
          active: true,
        },
      ],
      requiresAuth: true,
    },

  },
  {
    path: '/admin/news/add',
    name: 'admin-news-add',
    component: () => import('@/views/admin/news/create.vue'),
    meta: {
      pageTitle: 'News',
      breadcrumb: [
        {
          text: 'News',
          to: '/admin/news',
        },
        {
          text: 'News Add',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/news/edit/:id',
    name: 'admin-news-edit',
    component: () => import('@/views/admin/news/Edit.vue'),
    meta: {
      pageTitle: 'News',
      breadcrumb: [
        {
          text: 'News',
          to: { name: 'admin-news' },
        },
        {
          text: 'Edit News',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/podcast/edit/:id',
    name: 'admin-podcast-edit',
    component: () => import('@/views/admin/podcast/Edit.vue'),
    meta: {
      pageTitle: 'Podcast',
      breadcrumb: [
        {
          text: 'Podcast',
          to: { name: 'admin-podcast' },
        },
        {
          text: 'Edit Podcast',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/admin/product',
    name: 'admin-product',
    component: () => import('@/views/admin/product/index.vue'),
    meta: {
      pageTitle: 'Product',
      breadcrumb: [
        {
          text: 'Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product-tarif',
    name: 'admin-product-tarif',
    component: () => import('@/views/admin/product/ProductTarif.vue'),
    meta: {
      pageTitle: 'Product Tarif',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Product Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/compare-product',
    name: 'admin-compare-product',
    component: () => import('@/views/admin/product/compare/Index.vue'),
    meta: {
      pageTitle: 'Compare Product',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/compare-product/edit/:key',
    name: 'admin-compare-product-edit',
    component: () => import('@/views/admin/product/compare/EditProduct.vue'),
    meta: {
      pageTitle: 'Edit Product',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Compare Product',
          to: { name: 'admin-compare-product' },
        },
        {
          text: 'Edit Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product/add',
    name: 'admin-product-add',
    component: () => import('@/views/admin/product/form.vue'),
    meta: {
      pageTitle: 'Product',
      breadcrumb: [
        {
          text: 'Product',
          to: '/admin/product',
        },
        {
          text: 'Product Add',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product/edit/:key',
    name: 'admin-product-edit',
    component: () => import('@/views/admin/product/form.vue'),
    meta: {
      pageTitle: 'Product',
      breadcrumb: [
        {
          text: 'Product',
          to: '/admin/product',
        },
        {
          text: 'Product Edit',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product/time-portofolio',
    name: 'admin-product-time-portofolio',
    component: () => import('@/views/admin/product/timeportofolio/Index.vue'),
    meta: {
      pageTitle: 'Time Portofolio',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Time Portofolio',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product/division',
    name: 'admin-product-division',
    component: () => import('@/views/admin/product/division/Index.vue'),
    meta: {
      pageTitle: 'Division',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Division',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product/business-line',
    name: 'admin-product-business-line',
    component: () => import('@/views/admin/product/business_line/Index.vue'),
    meta: {
      pageTitle: 'Business Line',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Business Line',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product/product-line',
    name: 'admin-product-product-line',
    component: () => import('@/views/admin/product/product_line/Index.vue'),
    meta: {
      pageTitle: 'Product Line',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Product Line',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/product/partner',
    name: 'admin-product-partner',
    component: () => import('@/views/admin/product/partner/Index.vue'),
    meta: {
      pageTitle: 'Partner',
      breadcrumb: [
        {
          text: 'Product',
          to: { name: 'admin-product' },
        },
        {
          text: 'Partner',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/logo',
    name: 'admin-settings-logo',
    component: () => import('@/views/admin/settings/Logo.vue'),
    meta: {
      pageTitle: 'Settings Logo',
      breadcrumb: [{ text: 'Settings Logo', active: true }], requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/footer',
    name: 'admin-settings-footer',
    component: () => import('@/views/admin/settings/Footer.vue'),
    meta: {
      pageTitle: 'Settings Footer',
      breadcrumb: [{ text: 'Settings Footer', active: true }], requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/products',
    name: 'admin-settings-products',
    component: () => import('@/views/admin/settings/products/Index.vue'),
    meta: {
      pageTitle: 'Settings Products',
      breadcrumb: [{ text: 'Settings Products', active: true }], requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/app-link',
    name: 'admin-settings-app-link',
    component: () => import('@/views/admin/settings/app-link/Index.vue'),
    meta: {
      pageTitle: 'Settings Apps Link',
      breadcrumb: [{ text: 'Settings Apps Link', active: true }], requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/tos',
    name: 'admin-settings-tos',
    component: () => import('@/views/admin/settings/terms-of-use/Index.vue'),
    meta: {
      pageTitle: 'Settings Terms Of Use',
      breadcrumb: [{ text: 'Settings Terms Of Use', active: true }], requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/contacts',
    name: 'admin-settings-contacts',
    component: () => import('@/views/admin/settings/contacts/Index.vue'),
    meta: {
      pageTitle: 'Settings Contacts',
      breadcrumb: [{ text: 'Settings Contacts', active: true }], requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/contacts/add',
    name: 'admin-settings-contacts-add',
    component: () => import('@/views/admin/settings/contacts/Create.vue'),
    meta: {
      pageTitle: 'Add Contact',
      breadcrumb: [
        {
          text: 'Settings Contacts',
          active: false,
          to: '/admin/settings/contacts',
        },
        { text: 'Add', active: true },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/contacts/edit/:contactId',
    name: 'admin-settings-contacts-edit',
    component: () => import('@/views/admin/settings/contacts/Edit.vue'),
    meta: {
      pageTitle: 'Edit Contact',
      breadcrumb: [
        {
          text: 'Settings Contacts',
          active: false,
          to: '/admin/settings/contacts',
        },
        { text: 'Edit', active: true },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/settings/chat',
    name: 'admin-settings-chat-index',
    component: () => import('@/views/admin/chat/index.vue'),
    meta: {
      pageTitle: 'Chat',
      breadcrumb: [
        { text: 'Chat', active: true },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/pcc',
    name: 'admin-pcc-index',
    component: () => import('@/views/admin/pcc/Index.vue'),
    meta: {
      pageTitle: 'PCC',
      breadcrumb: [
        {
          text: 'PCC',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/pcc/add',
    name: 'admin-pcc-add',
    component: () => import('@/views/admin/pcc/Create.vue'),
    meta: {
      pageTitle: 'Add PCC',
      breadcrumb: [
        {
          text: 'Add PCC',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/pcc/edit/:pccId',
    name: 'admin-pcc-edit',
    component: () => import('@/views/admin/pcc/Edit.vue'),
    meta: {
      pageTitle: 'Edit PCC',
      breadcrumb: [
        {
          text: 'Edit PCC',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/users',
    name: 'admin-users-index',
    component: () => import('@/views/admin/users/Index.vue'),
    meta: {
      pageTitle: 'User List',
      breadcrumb: [
        {
          text: 'User List',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/users/create',
    name: 'admin-users-create',
    component: () => import('@/views/admin/users/Form.vue'),
    meta: {
      pageTitle: 'Add User',
      breadcrumb: [
        {
          text: 'User',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/users/edit/:key',
    name: 'admin-users-edit',
    component: () => import('@/views/admin/users/Form.vue'),
    meta: {
      pageTitle: 'Edit User',
      breadcrumb: [
        {
          text: 'User',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/nps',
    name: 'admin-nps',
    component: () => import('@/views/admin/nps/index.vue'),
    meta: {
      pageTitle: 'NPS',
      breadcrumb: [
        {
          text: 'NPS',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/nps-mobile',
    name: 'admin-nps-mobile',
    component: () => import('@/views/admin/nps/indexMobile.vue'),
    meta: {
      pageTitle: 'NPS Mobile',
      breadcrumb: [
        {
          text: 'NPS Mobile',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/ldap-conf',
    name: 'admin-ldap-conf',
    component: () => import('@/views/admin/ldapconf/index.vue'),
    meta: {
      pageTitle: 'LDAP Config',
      requiresAuth: true,
      // breadcrumb: [
      //   {
      //     text: 'NPS',
      //     active: true,
      //   },
      // ],
    },
  },
  {
    path: '/admin/visitor',
    name: 'admin-visitor-index',
    component: () => import('@/views/admin/visitor/Index.vue'),
    meta: {
      pageTitle: 'Visitor',
      breadcrumb: [
        {
          text: 'Visitor',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/visitor-mobile',
    name: 'admin-mobile-visitor-index',
    component: () => import('@/views/admin/visitor/MobileIndex.vue'),
    meta: {
      pageTitle: 'Mobile Visitor',
      breadcrumb: [
        {
          text: 'Mobile Visitor',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/app-version',
    name: 'app-version-index',
    component: () => import('@/views/admin/appVersion/index.vue'),
    meta: {
      pageTitle: 'App Version',
      breadcrumb: [
        {
          text: 'App Version',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/app-version/add',
    name: 'app-version-add',
    component: () => import('@/views/admin/appVersion/Form.vue'),
    meta: {
      pageTitle: 'App Version',
      breadcrumb: [
        {
          text: 'App Version',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/app-version/edit/:key',
    name: 'app-version-edit',
    component: () => import('@/views/admin/appVersion/Form.vue'),
    meta: {
      pageTitle: 'App Version',
      breadcrumb: [
        {
          text: 'App Version',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/admin/log',
    name: 'tracker-index',
    component: () => import('@/views/admin/tracker/index.vue'),
    meta: {
      pageTitle: 'User Log',
      breadcrumb: [
        {
          text: 'User Log',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
]

routes.forEach(element => {
  element.meta.page_admin = true
})

export default routes
